import React, { useRef, useState } from 'react'
import { Modal, Pressable, StyleSheet, Text, TouchableOpacity, View } from 'react-native'
import { DS } from '@/design-system'

interface SelectPickerProps {
  data: string[]
  defaultValue?: string
  onSelect: (value: string) => void
}

export function SelectPicker({ data, defaultValue, onSelect }: SelectPickerProps) {
  const [selected, setSelected] = useState(defaultValue ?? data[0])
  const [open, setOpen] = useState(false)
  const [position, setPosition] = useState({ top: 0, left: 0, width: 0 })
  const buttonRef = useRef<View>(null)

  const handleOpen = () => {
    buttonRef.current?.measure((_x, _y, width, height, pageX, pageY) => {
      setPosition({ top: pageY + height, left: pageX, width })
      setOpen(true)
    })
  }

  const handleSelect = (item: string) => {
    setSelected(item)
    onSelect(item)
    setOpen(false)
  }

  return (
    <>
      <Pressable ref={buttonRef} onPress={handleOpen} style={styles.button}>
        <Text style={styles.buttonText}>{selected}</Text>
        <DS.Icon
          name="CaretDown"
          width={16}
          height={16}
          color={DS.palette['Global/Black']}
          style={{ transform: [{ rotate: open ? '0deg' : '180deg' }] }}
        />
      </Pressable>

      <Modal visible={open} transparent animationType="none" onRequestClose={() => setOpen(false)}>
        <TouchableOpacity style={styles.overlay} activeOpacity={1} onPress={() => setOpen(false)}>
          <View style={[styles.list, { top: position.top, left: position.left, width: position.width }]}>
            {data.map((item) => (
              <TouchableOpacity key={item} onPress={() => handleSelect(item)} style={styles.row} activeOpacity={0.7}>
                <Text style={styles.rowText}>{item}</Text>
              </TouchableOpacity>
            ))}
          </View>
        </TouchableOpacity>
      </Modal>
    </>
  )
}

const ROW_HEIGHT = 44

const styles = StyleSheet.create({
  button: {
    height: 48,
    marginTop: 6,
    borderWidth: 1,
    borderColor: DS.palette['Brand/Light Grey'],
    borderRadius: 8,
    backgroundColor: DS.palette['Global/White'],
    paddingHorizontal: 10,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  buttonText: {
    fontSize: 16,
    color: DS.palette['Global/Black']
  },
  overlay: {
    flex: 1
  },
  list: {
    position: 'absolute',
    backgroundColor: DS.palette['Global/White'],
    borderRadius: 8,
    borderWidth: 1,
    borderColor: DS.palette['Brand/Light Grey'],
    overflow: 'hidden',
    elevation: 4,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.12,
    shadowRadius: 4
  },
  row: {
    height: ROW_HEIGHT,
    justifyContent: 'center',
    paddingHorizontal: 10
  },
  rowText: {
    fontSize: 16,
    color: DS.palette['Global/Black']
  }
})
